import { getStorage } from '@ms/utils/storage'
import GAME_CONFIG from './config.json'

const { cacheGameNames } = GAME_CONFIG

const RECENTLY_CASINO_PLAYED = 'RECENTLY_CASINO_PLAYED'

export const setCasinoCache = (name) => {
  name = name.toLowerCase()
  if (!cacheGameNames.includes(name)) return false
  const cacheData = getCasinoCache()
  if (cacheData) {
    const index = cacheData.findIndex((x) => x.gameName === name)
    const data = { gameName: name, time: Date.now() }
    if (index !== -1) cacheData.splice(index, 1)
    cacheData.unshift(data)
    localStorage.setItem(RECENTLY_CASINO_PLAYED, JSON.stringify(cacheData))
  } else {
    const data = [{ gameName: name, time: Date.now() }]
    localStorage.setItem(RECENTLY_CASINO_PLAYED, JSON.stringify(data))
  }
}

export const getCasinoCache = () => getStorage(RECENTLY_CASINO_PLAYED)

export const isRecentlyPlayed = (game) => {
  const cacheData = getCasinoCache()
  if (!cacheData) return false

  const name = game.gameName.toLowerCase()
  const index = cacheData.findIndex((x) => x.gameName === name)
  if (index !== -1) {
    const { time } = cacheData[index]
    return (Date.now() - time) / 3600000 <= 168
  }
  return false
}
